function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: 'Options',
  props: {
    rootPrefixCls: String,
    haveQuickJumper: {
      type: Boolean,
      default: true
    },
    locale: Object,
    haveConfirmBtn: Boolean,
    current: Number
  },
  data: function data() {
    return {
      pageNo: ''
    };
  },
  computed: {
    componentClass: function componentClass() {
      return "".concat(this.rootPrefixCls, "-options");
    },
    classes: function classes() {
      var componentClass = this.componentClass;
      return _defineProperty({}, componentClass, true);
    },
    jumperClasses: function jumperClasses() {
      var componentClass = this.componentClass;
      return _defineProperty({}, "".concat(componentClass, "-quick-jumper"), true);
    }
  },
  methods: {
    // Q3需求直接不让输入非数字
    // http://opensource.cnsuning.com/uxcool/lerna-uxcool/issues/190
    onInput: function onInput(e) {
      var target = e.target;
      var value = target.value;
      var trimmedVal = value ? value.trim() : '';

      if (trimmedVal === '' || /^\d+$/.test(trimmedVal)) {
        this.pageNo = trimmedVal;
      }

      target.value = this.pageNo;
    },
    go: function go() {
      var pageNo = this.pageNo;

      if (pageNo === '') {
        return;
      }

      var page = Number(pageNo);
      this.pageNo = '';
      this.$emit('on-quick-jumper', page);
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.haveQuickJumper ? _c('li', {
    class: _vm.classes
  }, [_c('div', {
    class: _vm.jumperClasses
  }, [_vm._v(" " + _vm._s(_vm.locale.jump_to) + " "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.pageNo
    },
    on: {
      "input": _vm.onInput,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.go($event);
      }
    }
  }), _vm._v(" " + _vm._s(_vm.locale.page) + " "), _vm.haveConfirmBtn ? _c('button', {
    on: {
      "click": _vm.go
    }
  }, [_vm._v(" " + _vm._s(_vm.locale.confirm) + " ")]) : _vm._e()])]) : _vm._e();
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "options.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;